import styles from '../../styles/components/Controls.module.scss';

export const ButtonsNewGame = () => {
	return (
		<>
			<button className={styles.again}>Try Again</button>
			<button className={styles.new}>New Registration</button>
		</>
	);
}